import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState, useEffect } from "react";
import { Load } from "../load/load";
import { obtenerAlmacenProductosLimpieza, actualizarAlmacenProductosLimpieza } from "../../api/almacenProductosLimpieza"
import queryString from "query-string";
import { registraMovimientosAPL } from "../../api/movimientosAlmacenPL";
import { map } from "lodash";
import { listarDepartamentos } from "../../api/departamentos";
import { LogsInformativos } from "../logs/logs";

export default function MovimientosAPL({ history, setShow, idArticuloAPL }) {
    const [formData, setFormData] = useState(initialFormValue());

    const [listarDepartamento, setListDepartamento] = useState([]);

    const obtenerDepartamento = () => {
        try {
            listarDepartamentos()
                .then((response) => {
                    const { data } = response;

                    if (!listarDepartamento && data) {
                        setListDepartamento(formatModelDepartamento(data));
                    } else {
                        const datosDepartamento = formatModelDepartamento(data);
                        setListDepartamento(datosDepartamento);
                    }
                })
                .catch((e) => { });
        } catch (e) { }
    };

    useEffect(() => {
        obtenerDepartamento();
    }, []);

    //load
    const [loading, setLoading] = useState(true);

    const [nombreProducto, setNombreProducto] = useState("");
    const [idArticulo, setIdArticulo] = useState("");
    const [cantidadEntrada, setCantidadEntrada] = useState("");
    const [cantidadSalida, setCantidadSalida] = useState("");

    useEffect(() => {
        try {
            obtenerAlmacenProductosLimpieza(idArticuloAPL).then(response => {
                const { data } = response;
                setIdArticulo(data._id);
                setNombreProducto(data.producto);
                setCantidadEntrada(Number(data.entrada));
                setCantidadSalida(Number(data.salida));
            }).catch((e) => {
                if (e.message === 'Network Error') {
                    console.log("No hay internet")
                }
            })
        } catch (e) {
            console.log(e)
        }
    }, []);

    useEffect(() => {
        // Simula una carga de datos
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    //insert
    const onSubmit = (e) => {
        e.preventDefault();

        if (!formData.tipo || !formData.cantidad) {
            toast.warning("Completa el formulario");
        } else {
            try {
                setLoading(true);

                const dataTemp = {
                    idArticuloAPL: idArticulo,
                    producto: nombreProducto,
                    tipo: formData.tipo,
                    cantidadMovimiento: formData.cantidad,
                    departamento: formData.departamento,
                    observaciones: formData.observaciones
                };

                const dataTemp2 = {
                    entrada: formData.tipo == "Entrada" ? cantidadEntrada + Number(formData.cantidad) : cantidadEntrada,
                    salida: formData.tipo == "Salida" ? cantidadSalida + Number(formData.cantidad) : cantidadSalida
                };
                registraMovimientosAPL(dataTemp).then((response) => {
                    const { data } = response;
                    //notificacion
                    actualizarAlmacenProductosLimpieza(idArticulo, dataTemp2).then((response) => {
                        history({
                            search: queryString.stringify(""),
                        });
                    });
                    toast.success(data.mensaje);
                    LogsInformativos("Se ha registrado el movimiento del producto " + dataTemp.producto + " en el almacen de productos de limpieza", dataTemp)
                    history({
                        search: queryString.stringify(""),
                    });
                    setLoading(false);
                    setShow(false);
                    //cancelarRegistro()
                });
            } catch (e) {
                console.log(e);
            }
        }
    };

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const palabraEspecifica = "TABLILLA"

    // Convertir ambas la cadena y la palabra a minúsculas (o mayúsculas)
    const cadenaEnMinusculas = nombreProducto.toLowerCase();
    const palabraEnMinusculas = palabraEspecifica.toLowerCase();

    // Utilizar includes() en las cadenas convertidas
    const contienePalabra = cadenaEnMinusculas.includes(palabraEnMinusculas);

    return (
        <>
            {loading && <Load />}
            <div className="contact-form">
                <Form onSubmit={onSubmit} onChange={onChange}>
                    <br />
                    <Form.Label className="lblTonoOS">
                        Movimiento:
                    </Form.Label>
                    <Form.Control
                        as="select"
                        placeholder="Tipo"
                        name="tipo"
                        defaultValue={formData.tipo}
                    >
                        <option value="">Elige una opcion</option>
                        <option value="Entrada">Entrada</option>
                        <option value="Salida">Salida</option>
                    </Form.Control>
                    <br />
                    <Form.Label className="lblTonoOS">
                        Departamento:
                    </Form.Label>
                    <Form.Control
                        name="departamento"
                        as="select"
                        placeholder="Departamento"
                        //onChange={(e) => setTonoSuperior(e.target.value)}
                        defaultValue={formData.departamento}
                    >
                        <option>Elige una opción</option>
                        <option value="no aplica">No aplica</option>
                        {map(listarDepartamento, (cat, index) => (
                            <option key={index} value={cat?.nombre}>
                                {cat?.nombre}
                            </option>
                        ))}
                    </Form.Control>
                    <br />
                    <Form.Label className="lblTonoOS">
                        Cantidad:
                    </Form.Label>
                    <Form.Control
                        placeholder="cantidad del movimiento"
                        type="text"
                        name="cantidad"
                        defaultValue={formData.cantidad}
                    />
                    <br />
                    {contienePalabra && (
                        <>
                            <Form.Label className="lblTonoOS">
                                Observaciones:
                            </Form.Label>
                            <Form.Control
                                placeholder="Observaciones"
                                type="text"
                                as="textarea"
                                name="observaciones"
                                defaultValue={formData.observaciones}
                            />
                            <br />
                        </>
                    )}
                    <label></label>
                    <input className="submit" value="Enviar" type="submit" />
                </Form>
            </div>
        </>
    );
}

function initialFormValue() {
    return {
        tipo: "",
        cantidad: "",
        departamento: "",
        observaciones: ""
    };
}

function formatModelDepartamento(data) {
    const dataTemp = [];
    data.forEach((data) => {
        dataTemp.push({
            id: data._id,
            folio: data.folio,
            nombre: data.nombre,
            estado: data.estado
        });
    });
    return dataTemp;
}

